var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-slideInOverlay", class: { "is-open": _vm.isOpen } },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isOpen
          ? _c("div", {
              staticClass: "c-slideInOverlay__background",
              on: { click: _vm.close }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-slideInOverlay__inner" }, [
        _c("div", { staticClass: "c-slideInOverlay__header" }, [
          _vm.isOpen
            ? _c(
                "div",
                {
                  staticClass: "c-slideInOverlay__close o-btn o-btn--return",
                  on: { click: _vm.close }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.translations["Back"]) +
                      "\n            "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-slideInOverlay__heading" },
            [_vm._t("heading")],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-slideInOverlay__tools" },
            [_vm._t("tools")],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-slideInOverlay__wrapper customscroll" }, [
          _c(
            "div",
            { staticClass: "c-slideInOverlay__body" },
            [_vm._t("body"), _vm._v(" "), _vm._t("secondaryBody")],
            2
          )
        ]),
        _vm._v(" "),
        _vm.hasFooterSlot
          ? _c(
              "div",
              { staticClass: "c-slideInOverlay__footer" },
              [_vm._t("footer")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showLoader
          ? _c(
              "div",
              { staticClass: "c-slideInOverlay__loader" },
              [_c("inline-loader")],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }